import React from 'react';
import { Typography } from 'material-ui';
import { assets } from '../../../assets';
import { CircularProgress } from '@material-ui/core';
import { convertCO2GramsToBestUnit } from '../../../utils/unitHelper';

export class AvoidedCO2ConvertedNuclearWaste extends React.Component {
  render() {
    const {
      classes,
      t,
      energyInWh,
      loading,
      nuclear_waste_for_1mwh_nuclear_electricity_in_g,
      user,
    } = this.props;

    if (loading) {
      return <CircularProgress size={10} className={classes.buttonProgress} />;
    }

    /*
    The production of 1 MWh of nuclear electricity in France produces about 11 g of radioactive waste.
    Source: http://cpdp.debatpublic.fr/cpdp-dechets-radioactifs/docs/pdf/dossier-initialisation/edf.pdf


    1 MWh -> 11g
    totalEnergyMatchedYTD/1 000 000 -> X g

    */

    const ONE_MILLION = 10 ** 6;

    let totalEnergyMatchedInWh = parseFloat(energyInWh);
    let totalEnergyMatchedIn_MWh = totalEnergyMatchedInWh / ONE_MILLION;

    let nuclearWasteQuantityInGrams =
      nuclear_waste_for_1mwh_nuclear_electricity_in_g *
      totalEnergyMatchedIn_MWh;
    let [printedNuclearWasteQuantity, unit] = convertCO2GramsToBestUnit(
      nuclearWasteQuantityInGrams,
      t,
      user
    );

    return (
      <div>
        <div style={{ marginBottom: 20 }}>
          <img
            src={assets.icons.nuclearPowerPlantIcon}
            style={{
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
              width: 40,
              height: 40,
            }}
            alt=""
          />
        </div>
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          align="center"
          color="textSecondary"
          style={{ fontSize: '0.875rem' }}
        >
          <span style={{ fontSize: '1.2rem', color: '#F87733' }}>
            {printedNuclearWasteQuantity} {unit}
          </span>
        </Typography>
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          align="center"
          color="textSecondary"
          style={{ fontSize: '0.875rem' }}
        >
          {t('of nuclear waste')}
        </Typography>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/ConvertedAvoidedCO2/AvoidedCO2ConvertedNuclearWaste.js